/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the variable the same as the type */ 
export const StyledFloatingInputTypes = {
    primary: "primary" as const,
    secondary: "secondary" as const
};

export type StyledFloatingInputTypes = typeof StyledFloatingInputTypes[keyof typeof StyledFloatingInputTypes];
